export default {
    computed: {
        resourceType() {
            return this.$store.getters.resourceTypeById(this.resourceTypeId)
        },
    },
}
